// @flow

export const PAGES = {
  SPECIALS: 'specials',
  VIRTUAL_WORLD: 'virtual-world',
  VIRTUAL: 'virtual',
  ALL_RACES: 'allRaces',
  EVENTS: 'events',
  MATCHES: 'matches',
  HIGHLIGHTS: 'highlights',
  HOMEPAGE: 'homepage',
  DAILY_LIST: 'daily-list',
  COMPETITIONS: 'competitions',
  INPLAY: 'in-play',
  COUPONS: 'coupons',
  TOP_BETS: 'top-bets',
  LOTTERIES: 'lotteries',
  POPULAR_MATCHES: 'popular-matches',
  ENGLISH_PREMIER_LEAGUE: 'english-premier-league',
  HORSES: 'horses',
  MEETINGS: 'meetings',
  TODAY: 'today',
  ALL: 'all',
  PROMOTIONS: 'promotions',
  OTHER: 'other',
  FUTURE_RACING: 'future-races',
  YOUR_ODDS: 'yourodds',
};

export const SPORTS = {
  HORSE_RACING: 'horse-racing',
  AMERICAN_FOOTBALL: 'american-football',
  BASEBALL: 'baseball',
  BASKETBALL: 'basketball',
  BOXING: 'boxing',
  CRICKET: 'cricket',
  CYCLING: 'cycling',
  DARTS: 'darts',
  E_SPORTS: 'e-sports',
  FOOTBALL: 'football',
  GOLF: 'golf',
  GREYHOUNDS: 'greyhounds',
  ICE_HOCKEY: 'ice-hockey',
  LOTTERIES: 'lotteries',
  MOTOR_RACING: 'motor-racing',
  MOTORBIKES: 'motorbikes',
  POKER: 'poker',
  POLITICS: 'politics',
  POOL: 'pool',
  RUGBY_LEAGUE: 'rugby-league',
  RUGBY_UNION: 'rugby-union',
  SNOOKER: 'snooker',
  TABLE_TENNIS: 'table-tennis',
  TENNIS: 'tennis',
  TV_SPECIALS: 'tv-specials',
  UFC: 'ufc',
  VOLLEYBALL: 'volleyball',
};

export const PREFIXES = {
  EVENTS: 'OB_EV',
  COMPETITIONS: 'OB_TY',
  COUPONS: 'OB_CP',
};

export const APP_DATA = {
  APP_TYPE_APP: 'App',
  APP_TYPE_WEBSITE: 'Website',
  APP_ID_IOS: '465712788',
  APP_ID_ANDROID: 'com.williamhill.sports.android',
  APP_NAME_IOS: 'William Hill Sports Betting',
  APP_NAME_ANDROID: 'William Hill - Sports Betting & Odds',
  DEVICE_OS_IOS: 'ios',
  DEVICE_OS_ANDROID: 'android',
};

export const BETSLIP_INIT_COMPLETE: 'betslip.init.complete' = 'betslip.init.complete';
export const BETSLIP_INIT_SUCCESS: 'betslip.events.init.success' = 'betslip.events.init.success';
export const ANALYTICS_ADAPTER_READY: 'wh.analytics.adapter.ready' = 'wh.analytics.adapter.ready';

export const SPORTS_PRODUCT_NAME = 'Sports';
export const SPORTSBOOK = 'Sportsbook';

export const EN_GB = 'en-gb';

export const CURRENCY_CODES = {
  '&pound;': 'GBP',
  '&euro;': 'EUR',
  $: 'USD',
  'C $': 'CAD',
  'DKK&nbsp;': 'DKK',
  '&yen;': 'JPY',
  'CHF&nbsp;': 'CHF',
};

export const PAGEVIEW_TRIGGERS = {
  PAGECHANGE: 'navigation.pageChanged',
  SNIPPETCHANGE: 'navigation.snippetChanged',
  TAB_CLICKED: 'event:tab_clicked',
  VIRTUAL_WORLD_EVENTS_LOADED: 'analytics.virtual-app.events-loaded',
};
